<template>
  <div class="ankang-index">
    <div class="page-shell">
      <div class="page-panel">
        <div class="banner-wrap">
          <img class="banner-img" src="/static/images/ankang/banner.png" alt="秦岭高山凰散养原生土鸡" />
          <img class="banner-tip" src="/static/images/ankang/tip.png" alt="秦岭高山凰散养原生土鸡" />
          <img class="banner-trace" src="/static/images/ankang/trace.png" alt="溯源信息" />
        </div>

        <div v-if="replyCode !== '300106' && replyCode !== '500'" class="content-section">
          <div class="auth-card">
            <div class="auth-icon-wrap">
              <img class="auth-icon" src="/static/images/ankang/dun.png" alt="正品认证" />
            </div>
            <div class="auth-content">
              <div class="auth-title">正品认证</div>
              <div class="auth-desc">
                您查询的产品为「秦岭高山凰」官方出品，全链路一物一码溯源可查，请放心食用。
              </div>
            </div>
          </div>

          <div class="time-card">
            <div class="time-row">
              <img class="time-icon" src="/static/images/ankang/cannder.png" alt="首次查询" />
              <div class="time-info">
                <div class="time-label">首次查询</div>
                <div class="time-value">{{ firstQueryTime }}</div>
              </div>
            </div>

            <div class="time-row time-row-last">
              <img class="time-icon" src="/static/images/ankang/cannder.png" alt="最新查询" />
              <div class="time-info">
                <div class="time-label">最新查询</div>
                <div class="time-value">{{ preQueryTime }}</div>
              </div>
            </div>
          </div>

          <button class="trace-btn" type="button" @click="goTrace">查看详细溯源信息</button>
        </div>
      </div>
    </div>

    <div v-if="showErrorModal" class="error-modal-mask">
      <div class="error-modal">
        <div class="error-modal-title">提示</div>
        <div class="error-modal-content">{{ errorMessage }}</div>
        <button class="error-modal-btn" type="button" @click="handleErrorConfirm">确认</button>
      </div>
    </div>
  </div>
</template>

<script>
import { getAntiData } from '../../api/api'

export default {
  name: 'AnKangIndex',
  data() {
    return {
      code: '',
      eno: process.env.ENV_NUM === '1' ? '138954451688' : '138152001162',
      replyCode: '',
      firstQueryTime: '',
      preQueryTime: '',
      showErrorModal: false,
      errorMessage: ''
    }
  },
  created() {
    this.initPage()
  },
  methods: {
    async initPage() {
      const params = this.$route.query || {}
      if (params.code) {
        this.code = params.code
        this.firstQueryTime = params.firstQueryTime || ''
        this.preQueryTime = this.getCurrentTime()
        return
      }
      if (params.c) {
        this.code = params.c.substring(0, 16)
        await this.loadAntiResultByCode(this.code)
        return
      }
    },
    async loadAntiResultByCode(code) {
      if (!code || !this.eno) {
        return
      }
      try {
        const res = await getAntiData(code, this.eno)
        const data = res.data
        if (!data || data.code === '500') {
          this.replyCode = '500'
          this.showErrorModal = true
          this.errorMessage = '暂时没有查询到该数码信息，请您核对后重新扫码或稍后再试。'
          return
        }
        this.replyCode = data.code || ''
        if (data.code === '300101' || data.code === '300102') {
          this.firstQueryTime = data.data && data.data.firstQueryTime ? data.data.firstQueryTime : ''
          this.preQueryTime = this.getCurrentTime()
          return
        }
        if (data.code === '300106') {
          this.showErrorModal = true
          this.errorMessage = '暂未查询到该数码信息，请您检查包装上的溯源码后重新查询。'
        }
      } catch (e) {
        this.replyCode = '500'
        this.showErrorModal = true
        this.errorMessage = '查询服务暂时有点忙，请稍后重新扫码或再试一次。'
      }
    },
    handleErrorConfirm() {
      window.location.href = '/ankang/scan'
    },
    getCurrentTime() {
      const now = new Date()
      const year = now.getFullYear()
      const month = String(now.getMonth() + 1).padStart(2, '0')
      const day = String(now.getDate()).padStart(2, '0')
      const hour = String(now.getHours()).padStart(2, '0')
      const minute = String(now.getMinutes()).padStart(2, '0')
      const second = String(now.getSeconds()).padStart(2, '0')
      return `${year}-${month}-${day} ${hour}:${minute}:${second}`
    },
    goTrace() {
      const traceCode = (this.code || '').substring(0, 16)
      if (!traceCode) {
        return
      }
      this.$router.push({
        path: '/ankang/trace',
        query: {
          code: traceCode
        }
      })
    }
  }
}
</script>

<style scoped>
.ankang-index {
  width: 100vw;
  height: 100vh;
  background: #ffffff;
  overflow: hidden;
}

.page-shell {
  width: 100%;
  height: 100%;
  padding: 0;
  box-sizing: border-box;
}

.page-panel {
  width: 100%;
  min-height: 100%;
  max-width: none;
  margin: 0;
  background: #ffffff;
  display: flex;
  flex-direction: column;
}

.banner-wrap {
  position: relative;
  width: 100%;
}

.banner-img {
  width: 100%;
  display: block;
}

.banner-tip {
  position: absolute;
  left: 7vw;
  bottom: 8.5vw;
  width: 48vw;
  display: block;
}

.banner-trace {
  position: absolute;
  right: 6vw;
  bottom: 8.5vw;
  width: 26vw;
  display: block;
}

.content-section {
  flex: 1;
  padding: 3.2vh 6vw 4.2vh;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.auth-card {
  display: flex;
  align-items: flex-start;
}

.error-modal-mask {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 20;
  padding: 0 7vw;
  box-sizing: border-box;
}

.error-modal {
  width: 100%;
  max-width: 320px;
  background: #ffffff;
  border-radius: 14px;
  overflow: hidden;
}

.error-modal-title {
  padding: 18px 20px 10px;
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  color: #333333;
}

.error-modal-content {
  padding: 0 20px 18px;
  text-align: center;
  font-size: 14px;
  line-height: 1.6;
  color: #666666;
  word-break: break-word;
}

.error-modal-btn {
  width: 100%;
  height: 48px;
  border: 0;
  border-top: 1px solid #ececec;
  background: #ffffff;
  font-size: 16px;
  font-weight: 600;
  color: rgb(179, 155, 119);
}

.auth-icon-wrap {
  margin-top: -0.6vh;
  width: 13.5vw;
  height: 13.5vw;
  max-width: 46px;
  max-height: 46px;
  border-radius: 50%;
  background: rgb(179, 155, 119);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.auth-icon {
  width: 6.8vw;
  max-width: 22px;
  display: block;
}

.auth-content {
  flex: 1;
  margin-left: 3.2vw;
}

.auth-title {
  font-size: 5.1vw;
  line-height: 1.1;
  color: rgb(179, 155, 119);
  font-weight: 700;
}

.auth-desc {
  margin-top: 1vh;
  font-size: 3.4vw;
  line-height: 1.45;
  color: #666666;
}

.time-card {
  margin-top: 2.4vh;
  padding: 2.5vh 5vw 2.3vh;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 3px 18px rgba(0, 0, 0, 0.08);
}

.time-row {
  display: flex;
  align-items: flex-start;
  padding-bottom: 2.2vh;
  border-bottom: 1px solid #efefef;
}

.time-row-last {
  padding-top: 2vh;
  padding-bottom: 0;
  border-bottom: 0;
}

.time-icon {
  width: 5.2vw;
  max-width: 18px;
  margin-left: 0.6vw;
  margin-top: -0.2vh;
  flex-shrink: 0;
}

.time-info {
  margin-left: 2.1vw;
}

.time-label {
  font-size: 3.2vw;
  line-height: 1.2;
  font-weight: 600;
  color: #5f646c;
}

.time-value {
  margin-top: 0.9vh;
  font-size: 3.2vw;
  line-height: 1.2;
  color: #4d5560;
  letter-spacing: 0.2px;
}

.trace-btn {
  width: 100%;
  height: 6.8vh;
  min-height: 52px;
  margin-top: 4vh;
  margin-bottom: 1vh;
  border: 0;
  border-radius: 8px;
  background: rgb(179, 155, 119);
  font-size: 4.2vw;
  font-weight: 600;
  color: #2f3540;
  padding: 0;
}

@media screen and (max-width: 350px) {
  .content-section {
    padding-left: 5vw;
    padding-right: 5vw;
  }

  .auth-title {
    font-size: 5vw;
  }

  .auth-desc {
    font-size: 3.6vw;
  }

  .time-label,
  .time-value {
    font-size: 3.8vw;
  }

  .trace-btn {
    min-height: 50px;
    font-size: 4.4vw;
  }
}

@media screen and (max-height: 700px) {
  .ankang-index {
    height: auto;
    min-height: 100vh;
    overflow: visible;
  }

  .page-shell {
    height: auto;
    min-height: 100vh;
  }

  .page-panel {
    min-height: auto;
  }

  .content-section {
    display: block;
    padding-bottom: 7vh;
  }

  .trace-btn {
    margin-top: 7.2vh;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AnKang/Index.vue